import {
    Button as UIButton,
    Menu as UiMenu,
    styled,
} from "@l2r-front/l2r-ui"

import { SubNetworksSelector as L2RSubNetworksSelector } from "../../components/SubNetworksSelector"

export const Button = styled(UIButton, { shouldForwardProp: (prop) => prop !== "large" })(({ theme, large }) => ({
    width: large ? 330 : 200,
    height: 40,
    display: "flex",
    justifyContent: "space-between",

    "&.MuiButtonBase-root": {
        backgroundColor: theme.palette["_components/app-bar/button/default"].dark,
        borderRadius: theme.spacing(3),
        color: "white",
        fontWeight: 600,
        padding: theme.spacing(0, 3),
    },
}))

export const NetworkNameWrapper = styled("div")(() => ({
    flexShrink: 1,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
}))

export const Menu = styled(UiMenu)(({ theme }) => ({
    marginTop: theme.spacing(1),

    "& .MuiPaper-root": {
        borderRadius: theme.spacing(3),
    },
}))

export const SubNetworksSelector = styled(L2RSubNetworksSelector)(({ theme }) => ({
    marginTop: theme.spacing(1),
}))

export const Badge = styled("div")(({ theme }) => ({
    flexShrink: 0,
    backgroundColor: theme.palette["info"].light,
    borderRadius: 1000,
    marginLeft: "auto",
    width: 36,
    height: 24,
    color: theme.palette["text/primary"].main,
}))